// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileWidgetAudienceFormFields-moduleformFieldsWrapper__e2W3T";
export { _1 as "formFieldsWrapper" }
